import { Route, Routes } from '@angular/router';
import { SplashComponent } from './components/splash/splash';
import { unauthGuard } from './guards/unauth.guard';

const unauthRoute = (route: Route): Route => ({
  ...route,
  canActivate: [unauthGuard]
});

export const routes: Routes = [
  { path: '', component: SplashComponent, pathMatch: 'full' },
  unauthRoute({
    path: 'login',
    loadComponent: () => import('./components/auth/login/login').then((m) => m.Login)
  }),
  unauthRoute({
    path: 'auth/forgot-password',
    loadComponent: () => import('./components/auth/request-password-reset/request-password-reset').then((m) => m.RequestPasswordResetComponent)
  }),
  unauthRoute({
    path: 'auth/reset-password',
    loadComponent: () => import('./components/auth/reset-password/reset-password').then((m) => m.ResetPasswordComponent)
  }),
  unauthRoute({
    path: 'auth/verify-email',
    loadComponent: () => import('./components/auth/verify-email/verify-email').then((m) => m.VerifyEmailComponent)
  }),
  unauthRoute({
    path: 'account/register',
    loadComponent: () => import('./components/auth/register/register').then((m) => m.Register)
  }),
  unauthRoute({
    path: 'account/verify-email',
    loadComponent: () => import('./components/auth/verify-email/verify-email').then((m) => m.VerifyEmailComponent)
  }),
  {
    path: 'licensing',
    loadComponent: () => import('./components/licensing/licensing').then((m) => m.LicensingComponent)
  },
  {
    path: 'account',
    loadChildren: () => import('./features/account/account.routes').then((m) => m.ACCOUNT_ROUTES)
  },
  { path: '**', redirectTo: '' }
];
